import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  InjectionToken,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { asyncScheduler, combineLatest, of, Subscription } from 'rxjs';
import {
  distinctUntilChanged,
  map,
  observeOn,
  startWith,
} from 'rxjs/operators';

import { FormBaseControlComponent } from './form-base-control/form-base-control.component';

export const FORM_BASE_CONTROL_CMP =
  new InjectionToken<FormBaseControlComponent>('formBaseControl');

@Directive({
  selector: '[pluginsFormBaseControlStyle]',
  standalone: true,
})
export class FormBaseControlStyleDirective implements AfterViewInit, OnDestroy {
  private control = inject(NgControl, { host: true, optional: true });
  private formBaseControlCmp = inject(FORM_BASE_CONTROL_CMP);
  private elemRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  private subscription?: Subscription;

  ngAfterViewInit(): void {
    this.subscription = combineLatest([
      this.formBaseControlCmp.focused$,
      this.control
        ? this.control.statusChanges!.pipe(
            startWith(this.control.status),
            observeOn(asyncScheduler),
            map(
              () => this.control!.status === 'INVALID' && this.control!.dirty,
            ),
          )
        : of(false),
    ])
      .pipe(
        distinctUntilChanged(
          ([prevFocused, prevInvalid], [currFocused, currInvalid]) =>
            prevFocused === currFocused && prevInvalid === currInvalid,
        ),
      )
      .subscribe(([focused, invalid]) => {
        this.renderer.setStyle(
          this.elemRef.nativeElement,
          'box-shadow',
          focused
            ? invalid
              ? `0 0 0 0.2rem rgba(255, 0, 0, 0.2)`
              : `0 0 0 0.2rem ${this.formBaseControlCmp.focusColor}`
            : 'none',
        );
        this.renderer.setStyle(
          this.elemRef.nativeElement,
          'border-color',
          invalid
            ? 'red'
            : focused
              ? this.formBaseControlCmp.baseColor
              : '#b0b0b0',
        );
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
